import Vue from 'vue';

let PageComponent = {
  name: 'delivery',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let delivery = document.querySelector('#delivery');
    if (delivery) {
      delivery.remove();
    }

    let url = '/api/templates/info/delivery';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/delivery/index.js